import { useCallback, useEffect, useState } from "react";

export default function useLocalStorageText(storageKey, defaultText = '') {
  // LOAD  "{\"val\":\"$.rootAccount['apps']['Klasa Server']['rels']['Alpha']['envs']['Dev']['cfgs']['Factory Settings']['CICD']\"}"
  const loadText = useCallback(() => {
    const loadedItem = localStorage.getItem(storageKey);
    if (loadedItem?.startsWith(`{"val":`)) {
      try {
        const parsedObj = JSON.parse(loadedItem);
        return parsedObj.val;
      }
      catch(error) {
        console.error('[useLocalStorageText loadText] Parse Error [storageKey: %s] [loadedItem: %s] Returning Default [defaultText: %s]',storageKey, loadedItem, defaultText);
        return defaultText;
      }
    }
    else {
      return defaultText;
    }
  }, [storageKey, defaultText]);

  // SAVE
  const saveText = useCallback((aText) => {    
    //console.log('[useLocalStorageText] [%s: %s]', storageKey, aText);    
    const wrapper = { val: aText };
    localStorage.setItem(storageKey, JSON.stringify( wrapper )); // must stringify - because this is serialization! not simply saving a string!
  }, [storageKey]);

  const [state, setState] = useState(loadText());

  useEffect(()=>{
    if (state) {
      saveText(state);
    }
  },[state, saveText]);

  return {
    getText: state,
    setText: setState
  }
}
